<template>
	<!-- star -->

	<div class="youjiaopage_wrap">
		<nav2></nav2>
		<banner2 :bannerH="h1" :bannerP="p1" :bannerImg="Img1"></banner2>
<!--		&lt;!&ndash; 面包屑 &ndash;&gt;-->
<!--		<div class="Crumbs">-->
<!--			<div>当前位置：首页><span>新闻</span></div>-->
<!--		</div>-->
    <!-- 新闻内容 -->
    <div class="news_cont_zong">
      <div class="item2">
        <div class="item2_cont">
          <div
              class="item2_cont1"
              v-for="(item, index) in arrList"
              :key="index"
              @click="funUrl(index,arrList)"
          >
            <img :src="item.url" alt="" />
            <div class="item2_cont1_text">
              <div class="item2_cont1_text_top">
                <h1>
                  {{ item.h1 }}
                </h1>
                <p>
                  {{ item.p1 }}
                </p>
              </div>
              <div class="item2_cont1_text_btm">
                <div>{{ item.d1 }}</div>
                <p>查看更多></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
		<!-- 按钮板块 -->
<!--		<div class="btn">-->
<!--			<div class="btn_cont">-->
<!--				<div-->
<!--					:class="active === item.url ? 'active' : ''"-->
<!--					v-for="(item, index) in newsList"-->
<!--					:key="index"-->
<!--					@click="NewsDetails(item.url)"-->
<!--				>-->
<!--					{{ item.title }}-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->
		<!-- 新闻内容 -->
<!--		<router-view></router-view>-->
		<!-- 翻页列表 -->
		<!-- <div class="Pages">
      <div class="Pages_cont">
        <ul>
          <li>《</li>
          <li>1</li>
          <li>2</li>
          <li>3</li>
          <li>4</li>
          <li>5</li>
          <li>6</li>
          <li>...</li>
          <li>20</li>
          <li>》</li>
        </ul>
      </div>
    </div> -->

		<footer2></footer2>

		<!-- end -->
	</div>
</template>

<script>
import footer2 from "../components/footer.vue";
import banner2 from "../components/banner.vue";
import nav2 from "../components/nav.vue";

export default {
	name: "news",
	components: {
		footer2,
		nav2,
		banner2,
	},
	data() {
    return {
      Img1: require("../assets/img/news/newsbanner.png"),
      arrList: [
        {
          url: require("../assets/img/news/6/封面.png"),
          h1: "2024中国人工智能大会：创新驱动，智启新程",
          p1: "2024年12月14日，备受瞩目的第十届中国人工智能大会（CCAI 2024）在北京隆重开幕。此次盛会由中国人工智能学会主办，北京市科学技术委员会、中关村科技园区管理委员会及北京市海淀区人民政府共同支持，吸引了全球范围内的业界专家和科研人员齐聚一堂，共同探讨人工智能领域的最新进展和未来趋势。...",
          d1: "2024-12-26",
        },
        {
          url: require("../assets/img/news/头图_中关村国际创新中心.png"),
          h1: "《数字新势力：北京数字人才发展大会引领未来》",
          p1: "为深入探讨人工智能与教育的深度融合，推动数字人才发展，11月20日，“AI+教育创新与人才发展大会暨首届北京数字人才发展大会”在海淀区中关村国际创新中心启幕。...",
          d1: "2024-11-25",
        },
        {
          url: require("../assets/img/news/文章头图.png"),
          h1: "2024产学研融通创新活动：AI应用落地是重点",
          p1: "探索AI边界，重构数字场景，9月27日，2024产学研融通创新活动由中国科学技术协会企业创新服务中心、北京经济技术开发区管理委员会主办，中关村产业技术联盟联合会、中国通信工业协会数据中心委员会（CIDC）、北京通明湖信息城发展有限公司、京东云承办，数字开物、中国 IDC 圈、北京首科集团有限公司协办。...",
          d1: "2024-10-27",
        },
        {
          url: require("../assets/img/news/文章头图2.png"),
          h1: "人工智能应用实践：数据准备篇(2)",
          p1: "数据是模型训练的基础，良好的数据准备是确保模型性能的关键一步。本文将重点介绍数据准备阶段的关键步骤和技术，帮助大家有效地准备数据以支持机器学习和深度学习项目的顺利进行。...",
          d1: "2024-10-25",
        },
        {
          url: require("../assets/img/news/头图_人工智能应用实践.png"),
          h1: "人工智能应用实践：训练技术栈篇(1)",
          p1: "数据驱动中，模型训练是构建智能应用的核心环节，涉及数据预处理到模型优化的全部过程。本文旨在为技术新手和进阶者提供一个全面的模型训练技术栈指导，分享高效地进行机器学习和深度学习项目。...",
          d1: "2024-9-27",
        },
        {
          url: require("../assets/img/news/头图_2024世界人工智能大会.png"),
          h1: "2024世界人工智能大会:面向未来，迎接挑战",
          p1: "2024年7月4日世界人工智能大会（WAIC）在上海成功举行，经国务院批准，由外交部、国家发改委、教育部、科技部、工信部、国家网信办、中科院、中科协和上海市政府共同主办。打造“会议论坛、展览展示、评奖赛事、智能体验”四大板块，聚焦人工智能领域前沿技术、产业动向、向善治理等全球人工智能行业普遍关心...",
          d1: "2024-9-25",
        },
        {
          url: require("../assets/img/news/头图_人工智能在数据治理应用的思考.png"),
          h1: "人工智能在数据治理应用的思考",
          p1: "在信息爆炸的时代，大数据的重要性愈发凸显，企业和组织都在不断探索如何更好地采集、分析和利用海量的数据资源。然而，传统的数据处理方法已经无法满足快速增长的数据需求，使得大数据采集和分析过程面临着诸多挑战。为了应对这些挑战，人工智能技术应运而生，为大数据采集分析赋能，提供更高效、准确...",
          d1: "2024-4-15",
        },
      ],
    };
	},

	// watch: {
	//   $route(now, old) {
	//     // now: 变化之后的数据
	//     // old: 变化之前的数据
	//     let url = now.name;
	//     console.log(url);
	//     console.log(now, old);
	//     if (url.includes("TradeNews")) {
	//       this.active == "TradeNews";
	//     }
	//   },
	//   immediate: true,
	// },
	watch: {
		$route: {
			// 值发生变化时的回调函数
			handler(now) {
				//..... // now: 变化之后的数据
				// old: 变化之前的数据
				let url = now.name;

				// console.log(url);
				// console.log(now, old);
				if (url.includes("TradeNews")) {
					this.active = "TradeNews";
				} else if (url.includes("GroupNews")) {
					this.active = "GroupNews";
				} else {
					this.active = "MediaCoverage";
				}
			},
			immediate: true, //立即执行
		},
	},
	methods: {
    funUrl(index,arrList) {
      let i = arrList.length-1;
      if (index <= i) {
        let page = i;
        this.$router.push("/TradeNews" + (page-index));
      } else {
        alert("页面未创建无法跳转");
      }
    },
	},
};
</script>
<style scoped>
@charset "utf-8";
/*=========================Reset_start==========================*/
body,
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
dl,
dt,
dd,
ol,
ul,
li,
form,
table,
th,
td,
a,
img,
span,
strong,
var,
em,
input,
textarea,
select,
option {
	margin: 0;
	padding: 0;
}
/*去内外边距*/
html,
body {
	font-family: "微软雅黑", "宋体", Arail, Tabhoma;
	text-align: left;
}
/*字体 文本居左*/
ul {
	list-style: none;
}
/*去ul li 小点*/
img {
	border: 0 none;
}
/*img IE6 兼容问题*/
input,
select,
textarea {
	outline: 0;
}
/*去除点击蓝框*/
textarea {
	resize: none;
	overflow: auto;
}
/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
	border-collapse: collapse;
	border-spacing: 0;
}
/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
	font-weight: normal;
	font-style: normal;
}
/*特殊文字粗细 样式显示正常*/
a {
	text-decoration: none;
}
/*a标签去下划线*/
.clearfix:after {
	clear: both;
	content: "";
	display: block;
	height: 0;
}
/*清浮动*/
a {
	color: #000000;
}
/*==========================Reset_End===========================*/

.youjiaopage_wrap {
	width: 100vw;
	margin: 0 auto;
	height: 1000px;
}
/* 面包屑 */
.Crumbs {
	width: 1200px;
	height: 46px;
	margin: 0 auto;
}
.Crumbs {
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #999999;
	line-height: 17px;
}
.Crumbs div {
	line-height: 46px;
}
.Crumbs span {
	color: #000000;
}
/* 按钮 */

.btn_cont {
	display: flex;
	width: 1200px;
	margin: 0 auto;
	margin-left: 666px;
}
.btn_cont div {
	text-align: center;
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #444444;
	line-height: 40px;
	margin-right: 18px;
	width: 185px;
	height: 40px;
	background: #f6f6f6;
	border-radius: 6px;
	cursor: pointer;
}
.active {
	color: #ffffff !important;
	background: #23337f !important;
}
/* 新闻列表 */
.item_cont {
	width: 1200px;
	margin: 0 auto;
	margin-top: 40px;
}
.item_cont1 {
	display: flex;
	width: 1200px;
	height: 252px;
	background: #ffffff;
	box-shadow: 3px 3px 10px 0px rgba(0, 0, 0, 0.11);
}

.item_cont1 img {
	margin: 32px 48px 32px 32px;
	width: 300px;
	height: 188px;
	border: dashed;
}
.item_cont1_text {
	width: 868px;
}
.item_cont1_text_top {
	margin: 45px 0 16px 0;
	width: 732px;
	height: 112px;

	border-bottom: 1px solid #eaeaea;
}
.item_cont1_text_top > h1 {
	font-size: 16px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #23337f;
	line-height: 24px;
}
.item_cont1_text_top p {
	margin-top: 16px;
	width: 732px;
	height: 56px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 24px;
}
.item_cont1_text_btm {
	width: 732px;

	display: flex;
	justify-content: space-between;
}
.item_cont1_text_btm div {
	font-size: 24px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #23337f;
	line-height: 28px;
}
.item_cont1_text_btm p {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #23337f;
	line-height: 28px;
}
/* item2 */
.item2_cont {
	width: 1200px;
	margin: 0 auto;
	margin-top: 40px;
}
.item2_cont1 {
	margin-top: 30px;
	display: flex;
	width: 1200px;
	height: 252px;
  cursor: pointer;
	background: #f8f8f8;
	box-shadow: 3px 3px 10px 0px rgba(0, 0, 0, 0.11);
}

.item2_cont1 img {
	margin: 32px 48px 32px 32px;
	width: 300px;
	height: 188px;
	//border: dashed;
}
.item2_cont1_text {
	width: 868px;
}
.item2_cont1_text_top {
	margin: 45px 0 16px 0;
	width: 732px;
	height: 112px;
	border-bottom: 1px solid #eaeaea;
}
.item2_cont1_text_top > h1 {
	font-size: 24px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #3f3f3f;
	line-height: 24px;
}
.item2_cont1_text_top p {
	margin-top: 16px;
	width: 732px;
	height: 56px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 24px;
}
.item2_cont1_text_btm {
	width: 732px;
	display: flex;
	justify-content: space-between;
}
.item2_cont1_text_btm div {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #999999;
	line-height: 28px;
}
.item2_cont1_text_btm p {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #23337f;
	line-height: 28px;
}
/* 翻页 */
.Pages_cont {
	margin: 40px 0;
	margin-left: 715px;
}
.Pages_cont ul {
	display: flex;
}
.Pages_cont ul li {
	text-align: center;
	line-height: 40px;
	width: 40px;
	height: 40px;
	margin-right: 10px;
}
.Pages_cont ul li:hover {
	background: #23337f;
}
</style>
